import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { EActiveView } from '../../types/view';
import { ERegisterOrAuthStatus } from '../../types/phoneAuth';
import { ERequestStatus } from '../../types/requestStatus';
import { PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE, PHONE_AUTH_SEND_CODE_TYPE } from '../../constants/action_types';
import { changeView } from '../view';
import { sendCode as sendCodeApi, ESendCodeStatus, ESenderType } from '../../api/sendCode';
import { EAuthErrorType } from '../../types/phoneAuth/authErrorType';
export function sendCode() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var _getState, activeView, phone, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getState = getState(), activeView = _getState.view.active, phone = _getState.phoneAuth.phone;
            dispatch({
              status: ERequestStatus.Loading,
              type: PHONE_AUTH_SEND_CODE_TYPE
            });

            // сбрасываем ошибки авторизации по телефонному коду
            dispatch({
              status: ERegisterOrAuthStatus.Initial,
              type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE
            });
            _context.next = 5;
            return sendCodeApi(context, phone);
          case 5:
            result = _context.sent;
            if (!(result.status === ESendCodeStatus.Succeed)) {
              _context.next = 12;
              break;
            }
            dispatch({
              status: ERequestStatus.Succeed,
              type: PHONE_AUTH_SEND_CODE_TYPE,
              senderType: result.senderType,
              secondsToRetry: result.secondsToRetry,
              timeStamp: result.timeStamp
            });
            if (result.senderType === ESenderType.Sms && activeView !== EActiveView.PhoneAuthValidateSms) {
              dispatch(changeView(EActiveView.PhoneAuthValidateSms));
            }
            if (result.senderType === ESenderType.Call && activeView !== EActiveView.PhoneAuthValidateCall) {
              dispatch(changeView(EActiveView.PhoneAuthValidateCall));
            }
            _context.next = 31;
            break;
          case 12:
            if (!(result.status === ESendCodeStatus.Failed && result.errors.length > 0 && result.errors[0].code === EAuthErrorType.CodeInputLimitReached)) {
              _context.next = 18;
              break;
            }
            dispatch(changeView(EActiveView.PhoneAuth, {
              notice: {
                title: 'Попробуйте через час',
                text: 'Вы много раз ввели неверный код, и нам пришлось заблокировать аккаунт'
              }
            }));
            dispatch({
              status: ERequestStatus.Failed,
              type: PHONE_AUTH_SEND_CODE_TYPE,
              error: result.errors[0].code
            });
            return _context.abrupt("return");
          case 18:
            if (!(result.status === ESendCodeStatus.Failed && result.errors.length > 0 && result.errors[0].code === EAuthErrorType.TemporaryBlock)) {
              _context.next = 24;
              break;
            }
            dispatch(changeView(EActiveView.PhoneAuth, {
              notice: {
                title: 'Подождите 15 минут',
                text: 'Вы часто запрашивали коды — иногда так ведут себя роботы. Если вы живой человек, убедитесь, что номер ваш, и попробуйте чуть позже'
              }
            }));
            dispatch({
              status: ERequestStatus.Failed,
              type: PHONE_AUTH_SEND_CODE_TYPE,
              error: result.errors[0].code
            });
            return _context.abrupt("return");
          case 24:
            if (!(result.status === ESendCodeStatus.Failed && result.errors.length > 0 && result.errors[0].code === EAuthErrorType.PermanentBlock)) {
              _context.next = 30;
              break;
            }
            dispatch(changeView(EActiveView.PhoneAuth, {
              notice: {
                title: 'Аккаунт заблокирован',
                text: 'Напишите в поддержку'
              }
            }));
            dispatch({
              status: ERequestStatus.Failed,
              type: PHONE_AUTH_SEND_CODE_TYPE,
              error: result.errors[0].code
            });
            return _context.abrupt("return");
          case 30:
            dispatch({
              status: ERequestStatus.Failed,
              type: PHONE_AUTH_SEND_CODE_TYPE,
              error: result.message
            });
          case 31:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
}